import { Component, OnInit, ViewChild } from "@angular/core";
import { FilterConstants } from "src/app/constants/filterConstants";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { ConcessionaireService } from "../concessionaire.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { TranslateService } from "@ngx-translate/core";
import { TokenService } from "src/app/core/services/token.service";
import { FiltersComponent } from "src/app/shared/filters/filters.component";
import { ScreenConstants } from "src/app/constants/screenId.constants";
import { CommonService } from "src/app/core/services/common.service";

@Component({
  selector: "app-list-concessionaire",
  templateUrl: "./list-concessionaire.component.html",
  styleUrls: ["./list-concessionaire.component.sass"],
})
export class ListConcessionaireComponent implements OnInit {
  @ViewChild("insideTable") filtersInsideTable: FiltersComponent;
  public concessionaires: any[];
  public filtersTable: string;
  filtersTableJSON;
  public filtersSearch = "";
  filterList = FilterConstants.concessionaire;
  tableList = TableConstants.concessionaire;
  routing = RoutingConstants.concessionaireRouting;
  options = TableConstants.NotShowArrowUpDown;
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;

  showTableFilter: boolean = false;
  showFilterButtons: boolean = false;

  constructor(
    private concessionaireService: ConcessionaireService,
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private translateService: TranslateService,
    private tokenService: TokenService,
    private commonService: CommonService
  ) {
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      this.routing.id,
      ScreenConstants.admSistemas.concesionarios
    );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.filtersSearch = this.filtersTableStateService.composeFiltersInTable(
      this.filterList
    );
  }

  ngOnInit(): void {
    this.loadConcessionares();
  }

  loadConcessionares(): void {
    let filters = this.commonService.concatFilters(
      this.filtersTable,
      this.filtersSearch
    );
    this.concessionaireService.list(filters).subscribe(
      (data) => {
        this.concessionaires = data["content"];
        this.numPages = data["totalPages"] == 0 ? 1 : data["totalPages"];
        this.numElements = data["numberOfElements"];
        this.totalElements = data["totalElements"];
        if (data["content"] && data["content"].length == 0) {
          let message = this.translateService.instant(
            "messages.notFoundResutls"
          );
          this.toastrAlertService.toastrWarning(message);
          this.numPages = 1;
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  filterSearch(value: string) {
    this.filtersSearch = value;
    this.filtersTableStateService.setPageState(0);
    this.filtersTableJSON =
      this.filtersTableStateService.getFiltersTableState();
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.loadConcessionares();
  }

  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = value.filterTableString;
    this.loadConcessionares();
  }

  removeElements(ids: string[]) {
    this.concessionaireService.deleteConcessionaire(ids).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data["mensaje"]);
        this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
          this.routing.id,
          ScreenConstants.admSistemas.concesionarios
        );
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.loadConcessionares();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  buttonsHeader(item: string) {
    switch (item) {
      case "erase":
        this.filtersInsideTable.filtersValuesSearch = [];
        break;
      case "search":
        this.filtersSearch = this.filtersInsideTable.composeParams();
        this.filtersTableStateService.setPageState(0);
        this.filtersTableJSON =
          this.filtersTableStateService.getFiltersTableState();
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.loadConcessionares();
        break;
      case "toggleFilters":
        if (this.showTableFilter) {
          this.showTableFilter = false;
          this.showFilterButtons = false;
        } else {
          this.showTableFilter = true;
          this.showFilterButtons = true;
        }
        break;
    }
  }
  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }

  public showFilters(type: string) {
    if (type === "normal") {
      this.showTableFilter = true;
    }
    this.showFilterButtons = true;
  }
}
